import React, { useEffect } from 'react';
import SectionWrapper from './SectionWrapper';
import './Timeline.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

const timelineData = [
  {
    type: 'education',
    title: 'B.Sc. in Physics',
    institution: 'University of Missouri – St. Louis',
    date: '07/2019 – 12/2023',
    description: 'Graduated with minors in Computer Science and Mathematics. GPA: 3.78/4.0.',
  },
  {
    type: 'experience',
    title: 'Undergraduate Research Assistant',
    institution: 'University of Missouri – St. Louis',
    date: '01/2021 – 12/2023',
    description: 'Conducted spectroscopy research using NASA’s telescope for comet analysis.',
  },
  
  {
    type: 'experience',
    title: 'Student Teaching/Lab Assistant',
    institution: 'University of Missouri – St. Louis',
    date: '08/2021 – 01/2023',
    description: 'Led physics classes and supervised laboratory work for undergraduate students.',
  },


  {
    type: 'experience',
    title: 'Public Engagement Intern (Programmer)',
    institution: 'American Physical Society',
    date: '05/2022 – 08/2022',
    description: 'Automated program processes with Python, reducing match time from days to seconds.',
  },


  {
    type: 'experience',
    title: 'Software Quality Engineer Intern',
    institution: 'Centene Corporation',
    date: '05/2023 – 08/2023',
    description: 'Performed Agile-based software testing and debugging in a fast-paced team.',
  },
  {
    type: 'experience',
    title: 'Social Network Data Analyst',
    institution: 'American Physical Society',
    date: '02/2024 – 10/2024',
    description: 'Analyzed teacher networks and presented at national physics education meetings.',
  },
  {
    type: 'education',
    title: 'M.Sc. in Quantum Science and Technology',
    institution: 'Technical University of Munich',
    date: '10/2024 – Present',
    description: 'Focus on Quantum Cryptography and Communication systems.',
  },
];

const Timeline = () => {
  useEffect(() => {
    AOS.init({
      duration: 600,
      offset: window.innerWidth < 768 ? 10 : 100, //Lower offset on small screens
    });

    const progressLine = document.querySelector('.timeline-progress');
    const wrapper = document.querySelector('.timeline-wrapper');

    if (!progressLine || !wrapper) return;

    const updateProgress = () => {
      const dots = document.querySelectorAll('.timeline-dot');
      if (!dots.length) return;

      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const scrollBottom = scrollTop + windowHeight;

      const firstDotTop = dots[0].getBoundingClientRect().top + scrollTop;
      const lastDot = dots[dots.length - 1];
      const lastDotCenter = lastDot.getBoundingClientRect().top + scrollTop + lastDot.offsetHeight / 2;

      const stopBuffer = 40;
      const dotOffset = 20;

      const cappedHeight = Math.min(
        scrollBottom - firstDotTop - stopBuffer,
        lastDotCenter - firstDotTop + dotOffset
      );

      const height = Math.max(0, cappedHeight);
      progressLine.style.height = `${height}px`;
    };

    window.addEventListener('scroll', updateProgress);
    setTimeout(updateProgress, 350);

    return () => window.removeEventListener('scroll', updateProgress);
  }, []);

  return (
    <SectionWrapper index={2}>
      <div className="timeline-container">
        <h2 className="timeline-title">Qualification</h2>
        <div className="timeline-subtitles">
          <div className="subtitle-left">Education</div>
          <div className="subtitle-center" />
          <div className="subtitle-right">Experience</div>
        </div>

        <div className="timeline-wrapper">
          {/* <div className="timeline-vertical-line"></div> */}
          <div className="timeline-progress"></div>

          {timelineData.map((item, index) => (
            <div
              key={index}
              className="timeline-row"
              data-aos="fade-up"
              data-aos-delay={index * 10}
            >
              <div className="timeline-left">
                {item.type === 'education' && (
                  <div className="timeline-item">
                    <div className="timeline-content">
                      <h3>{item.title}</h3>
                      <h4>{item.institution}</h4>
                      <span>{item.date}</span>
                      <p>{item.description}</p>
                    </div>
                  </div>
                )}
              </div>

              <div className="timeline-center">
                <div className="timeline-dot" />
              </div>

              <div className="timeline-right">
                {item.type === 'experience' && (
                  <div className="timeline-item">
                    <div className="timeline-content">
                      <h3>{item.title}</h3>
                      <h4>{item.institution}</h4>
                      <span>{item.date}</span>
                      <p>{item.description}</p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </SectionWrapper>
  );
};

export default Timeline;
